<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.apply_tech_support') }}</div>
    <div slot="body">
      <div class="steps-container">
        <a-steps :current="0" label-placement="vertical">
          <a-step title="购买" :description="'按次购买' + $t('scope.technical_consulting') + '服务'" />
          <a-step :title="$t('scope.technical_consulting')" description="扫描二维码进入专属企业微信群进行问题咨询" />
          <a-step :title="$t('scope.remote_assistance') + '(可选)'" :description="'如果问题仅通过' + $t('scope.technical_consulting') + '无法解决，可购买升级为' + $t('scope.remote_assistance') + '服务'" />
          <a-step title="解决" description="问题解决，完成服务。7个自然日后专属企业微信群解散" />
        </a-steps>
      </div>
      <div>{{ $t('scope.technical_consulting') }}服务价格为{{ customerCapability.consult_origin_rate }}元/次，活动期间折扣价为{{ customerCapability.consult_rate }}元/次。确定支付<span class="discount-price">{{ customerCapability.consult_rate }}元</span>购买？</div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SaasTechSupportCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('app', {
      customerCapability: state => state.customerCapability,
    }),
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const res = await this.params.onManager('create', {
          managerArgs: {
            data: {},
          },
        })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common.success'))
        // go to checkout page
        if (res.data.bill_id) {
          this.$router.push({ path: '/account/checkout', query: { bill_id: res.data.bill_id, from: 'tech-support' } })
        }
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .desc {
    color: rgba(0, 0, 0, 0.45);
  }
  .steps-container {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    ::v-deep .ant-steps-item-content {
      text-align: center;
      width: auto !important;
      max-width: 140px;
      white-space: normal;
    }
    ::v-deep .ant-steps-item-title {
      white-space: normal;
      line-height: 1.4;
      padding-right: 0 !important;
    }
    ::v-deep .ant-steps-item-description {
      white-space: normal;
      max-width: 140px;
      text-align: center;
      line-height: 1.4;
      padding-right: 0 !important;
    }
  }
  .discount-price {
    color: #ff4d4f;
    font-weight: bold;
  }
</style>
